import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import img1 from "../../../assets/category/category.png"; // Fallback image
import {API_BASE_URL} from "../../../config/api";

const Category = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/categories/allcategory`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        
        const data = await response.json();
        const subModelCategories = data.filter(category => category.categoryFallsOn === "Sub Model");
        setCategories(subModelCategories);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching categories:", err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const handleCategoryClick = (category) => {
    navigate(`/${category.categoryType}/${category.categoryName}`);
  };

  if (loading) {
    return <div className="w-full py-8 text-center">Loading categories...</div>;
  }

  if (error) {
    return <div className="w-full py-8 text-center text-red-500">Error: {error}</div>;
  }

  return (
    <div className="w-full py-8">
      <h2 className="text-3xl font-bold text-center mb-8">SHOP BY SUB MODEL</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {categories && categories.length > 0 ? (
          categories.map((category) => (
            <div
              key={category._id}
              className="relative group cursor-pointer"
              onClick={() => handleCategoryClick(category)}
            >
              <div className="aspect-square overflow-hidden rounded-lg">
                <img
                  src={category.categoryImage || "/placeholder.png"}
                  alt={category.categoryName}
                  className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300">
                <h3 className="text-white text-lg font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {category.categoryName}
                </h3>
              </div>
            </div>
          ))
        ) : (
          <div className="col-span-3 text-center py-8">No Sub Model categories found</div>
        )}
      </div>
    </div>
  );
};

export default Category;